
import { useState, useEffect } from 'react';
import {
  isMobile,
  isTablet,
  isDesktop,
  isAndroid,
  isIOS,
  isSafari,
  isChrome,
  isFirefox,
  isEdge,
  osName,
  osVersion,
  browserName,
  browserVersion,
  deviceType,
  mobileModel,
  mobileVendor
} from 'react-device-detect';

export const useEnhancedDeviceDetection = () => {
  const [screenInfo, setScreenInfo] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
    isLargeScreen: window.innerWidth >= 1400
  });

  useEffect(() => {
    const handleResize = () => {
      setScreenInfo({
        width: window.innerWidth,
        height: window.innerHeight,
        isLargeScreen: window.innerWidth >= 1400
      });
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return {
    // Device types
    isMobile,
    isTablet, 
    isDesktop,
    
    // Operating systems
    isAndroid,
    isIOS,
    osName,
    osVersion,
    
    // Browsers
    isSafari,
    isChrome,
    isFirefox,
    isEdge,
    browserName,
    browserVersion,
    
    // Device details
    deviceType,
    mobileModel,
    mobileVendor,
    
    // Screen info
    screenWidth: screenInfo.width,
    screenHeight: screenInfo.height,
    isLargeScreen: screenInfo.isLargeScreen,
    
    // Custom device categories
    isNativeApp: isAndroid || isIOS,
    isBrowserOnly: !isAndroid && !isIOS,
    isPWA: window.matchMedia('(display-mode: standalone)').matches,
    
    // Device info summary
    deviceSummary: {
      type: deviceType,
      os: osName,
      browser: browserName,
      platform: isAndroid ? 'android' : isIOS ? 'ios' : 'web'
    }
  };
};

// Example component showing how to use it
export const DeviceSpecificComponent = () => {
  const device = useEnhancedDeviceDetection();
  
  // Render different content based on device
  if (device.isAndroid) {
    return (
      <div className="android-specific">
        <h3>🤖 Android Device Detected</h3>
        <p>Model: {device.mobileModel || 'Unknown'}</p>
        <p>OS Version: {device.osVersion}</p>
        <button className="btn-android">Download Android App</button>
      </div>
    );
  }
  
  if (device.isIOS) {
    return (
      <div className="ios-specific">
        <h3>🍎 iOS Device Detected</h3>
        <p>Device: {device.mobileModel || 'Unknown'}</p>
        <p>OS Version: {device.osVersion}</p>
        <button className="btn-ios">Download from App Store</button>
      </div>
    );
  }
  
  return (
    <div className="browser-specific">
      <h3>🌐 Browser Access</h3>
      <p>Browser: {device.browserName} {device.browserVersion}</p>
      <p>OS: {device.osName}</p>
      <button className="btn-web">Continue in Browser</button>
    </div>
  );
};